import { Flex, Text, Box, Image, useClipboard } from "@chakra-ui/react";
import CopyIcon from "@/assets/copy.png";
import BottomButton from "@/components/Button/BottomButton";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "@/context/UserInfo";
import { shortenAddress } from "@/utils";
import { avatarImg } from "@/utils/avatars";
import KycStatus from "../myInfo/KycStatus";

const CreateOrgThird = () => {
  const navigate = useNavigate();
  const { orgName, senderAddress, address, avatarIndex } = useUserInfo();
  const { onCopy, value, setValue, hasCopied } = useClipboard(senderAddress);

  const handleConfirm = () => {
    navigate("/");
  };

  return (
    <Flex
      align={"center"}
      flexDir={"column"}
      sx={{
        padding: "30px 10px 0",
      }}
    >
      <Text
        sx={{
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        Your organization is{" "}
        <span
          style={{
            color: "#A44A25",
            textAlign: "center",
          }}
        >
          created
        </span>
      </Text>
      <Flex
        sx={{
          width: "100%",
          background: "#D8762B",
          position: "relative",
          height: "220px",
          marginTop: "36px",
          borderRadius: "20px",
          paddingTop: "40px",
        }}
        flexDir={"column"}
        align={"center"}
      >
        <Flex
          sx={{
            height: "60px",
            width: "60px",
            borderRadius: "50%",
            background: "#fff",
            fontSize: "40px",
            position: "absolute",
            top: "0",
            left: "50%",
            transform: "translate(-50%,-50%)",
          }}
          align={"center"}
          justify={"center"}
        >
          <Text sx={{}}>{avatarImg(avatarIndex)}</Text>
        </Flex>

        <Text
          sx={{
            color: "#FFF",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: 500,
          }}
        >
          {orgName}
        </Text>
        <Flex
          align={"center"}
          sx={{
            marginTop: "8px",
            cursor: "pointer",
          }}
          onClick={() => {
            onCopy();
          }}
        >
          <Text
            sx={{
              color: "#FFF",
              fontSize: "14px",
              marginRight: "2px",
            }}
          >
            {shortenAddress(senderAddress)}
          </Text>
          <Image
            src={CopyIcon}
            sx={{
              width: "12px",
            }}
          ></Image>
        </Flex>
        <KycStatus />
        <Text
          sx={{
            color: "#FFD096",
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 900,
            marginTop: "12px",
          }}
        >
          Balance:
        </Text>
        <Text
          sx={{
            fontSize: "50px",
            fontWeight: 900,
            marginTop: "6px",
            color: "#FFF",
            position: "relative",
          }}
        >
          0
        </Text>
        <Text
          sx={{
            fontSize: "20px",
            fontWeight: 900,
            color: "#FFF",
          }}
        >
          USDC
        </Text>
      </Flex>
      <BottomButton onClick={handleConfirm}>Confirm</BottomButton>
    </Flex>
  );
};

export default CreateOrgThird;
